import { render, staticRenderFns } from "./NotificationDot.vue?vue&type=template&id=e233691c&scoped=true"
import script from "./NotificationDot.vue?vue&type=script&lang=js"
export * from "./NotificationDot.vue?vue&type=script&lang=js"
import style0 from "./NotificationDot.vue?vue&type=style&index=0&id=e233691c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e233691c",
  null
  
)

export default component.exports